import React, { useEffect, useState, useRef } from "react";
import CardTeam from "../../../../../../components/Molecules/Cards/Teams/CardTeam";
import DirRespService from "../../../../../../services/Ing/DirResp/DirRespService";
import api from "../../../../../../services/APIService";

const HomeIngManTeams = () => {

	const [roleExtra, setRoleExtra] = useState([]);
	const [roleDiagnostic, setRoleDiagnostic] = useState([]);
	const [roleManager, setRoleManager] = useState([]);
	const [roleVerificateur, setRoleVerificateur] = useState([]);
	const [roleChargeAffaire, setRoleChargeAffaire] = useState([]);

	const [timeToRealod, setTimeToReload] = useState(false)

	const [projectUnassigned, setProjectUnassigned] = useState([])
	const [nextPageUrl, setNextPageUrl] = useState(null)
	const containerRef = useRef(null)
	const isLoadingRef = useRef(false)

	const [selectValue, setSelectValue] = useState(null);
	const [dateDeVisiteEnabled, setDateDeVisiteEnabled] = useState(false)
	const [dateDeRenduEnabled, setDateDeRenduEnabled] = useState(false)
	const [affaireEnabled, setAffaireEnabled] = useState(false)
	

	const [allIngsUsers, setAllIngsUsers] = useState([])

	const getVerificateur = async () => {
		const request = await DirRespService.getUsersByRole({ roles: "ROLE_ING_VERIF" })
		if (request.request.status === 200) {
			setRoleVerificateur(request.data["member"])
		}
	}

	const getProjectUnassigned = async () => {
		const params = {
		};
	
		if (selectValue) {
			params["users.id"] = selectValue;
		}
		if (dateDeVisiteEnabled) {
			params['order[visit.startAt]'] = "asc";
		}
		if (dateDeRenduEnabled) {
			params['order[study.estimatedEndAt]'] = "asc";
		}
		if (affaireEnabled) {
			params["orExists[ingMan]"] = "false"
			params["orExists[ingAff]"] = "false"
			params["orExists[ingChecker]"] = "false"
		}

		const request = await DirRespService.getAllUnassignedProjects(params, true)
		if (request.status === 200) {
			setProjectUnassigned(request.data["member"])
			setNextPageUrl(request.data["view"]?.next || null)
		}
	}
	
	const getManager = async () => {
		const request = await DirRespService.getUsersByRole({ roles: "ROLE_ING_MANAGER" })
		if (request.request.status === 200) {
			setRoleManager(request.data["member"])
		}
	}

	const getDiagnostic = async () => {
		const request = await DirRespService.getUsersByRole({ roles: "ROLE_ING_DIAG" })
		if (request.request.status === 200) {
			setRoleDiagnostic(request.data["member"])
		}
	}

	const filterByCollaborator = (event) => {
		if (event.target.value === "all") {
			setSelectValue("")
		} else {
			setSelectValue(event.target.value)
		}
	}

	const getExtra = async () => {
		const request = await DirRespService.getUsersByRole({ roles: "ROLE_ING_EXTRA" })
		if (request.request.status === 200) {
			setRoleExtra(request.data["member"])
		}
	}

	const getAffaire = async () => {
		const request = await DirRespService.getUsersByRole({ roles: "ROLE_ING_AFF" })
		if (request.request.status === 200) {
			setRoleChargeAffaire(request.data["member"])
		}
	}

	const getAllIngs = async () => {
		const request = await DirRespService.getAllCollaboratorsHighRoles({})
		if (request.request.status === 200) {
			setAllIngsUsers(request.data["member"])
		}
	}

	const filterPicker = async (visite) => {
		if (visite === "visite") {
			setDateDeRenduEnabled(false)
			setDateDeVisiteEnabled(true)
			setAffaireEnabled(false)
		} else if(visite === "rendu") {
			setDateDeVisiteEnabled(false)
			setDateDeRenduEnabled(true)
			setAffaireEnabled(false)
		} else if (visite === 'affaire') {
			setDateDeVisiteEnabled(false)
			setDateDeRenduEnabled(false)
			setAffaireEnabled(true)
		}
	}

	useEffect(() => {
		getManager()
		getVerificateur()
		getDiagnostic()
		getExtra()
		getAffaire()
		getAllIngs()
		getProjectUnassigned()
	}, []);

	useEffect(() => {
		setProjectUnassigned([])
		setNextPageUrl(null)
		isLoadingRef.current = false
		getProjectUnassigned()
	}, [timeToRealod, selectValue, dateDeRenduEnabled, dateDeVisiteEnabled, affaireEnabled])

	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		let timeoutId = null;

		const handleScroll = () => {
			if (isLoadingRef.current || !nextPageUrl) return;
			
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(() => {
				const scrollLeft = container.scrollLeft;
				const scrollWidth = container.scrollWidth;
				const clientWidth = container.clientWidth;

				const scrollPercentage = (scrollLeft + clientWidth) / scrollWidth;
				if (scrollPercentage >= 0.7 && nextPageUrl && !isLoadingRef.current) {
					isLoadingRef.current = true;
					const urlToLoad = nextPageUrl;
					
					const loadNextPage = async () => {
						const url = urlToLoad.replace("/api/", "");
						const request = await api.getAllData(url);
						
						if (request.status === 200) {
							setProjectUnassigned(prev => [...prev, ...request.data["member"]])
							setNextPageUrl(request.data["view"]?.next || null)
						}
						isLoadingRef.current = false;
					};
					
					loadNextPage();
				}
			}, 100);
		};

		container.addEventListener('scroll', handleScroll);
		return () => {
			container.removeEventListener('scroll', handleScroll);
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, [nextPageUrl])

	return (
		<div className="projects-in-progress">
			<div className="projects-in-progress-title">
				<h3 className="color-primary">Projets à attribuer</h3>
				<div className="projects-in-progress-title-container-filter">
					<select
						className={"select-custom-secondary"}
						onChange={filterByCollaborator}
					>
						<option value="all">Tous les collaborateurs</option>
						{allIngsUsers.map((collaborator, index) => (
							<option key={index} value={collaborator.id}>
								{collaborator.niceNames}
							</option>
						))}
					</select>

					<p onClick={() => filterPicker("visite")} className={`${dateDeVisiteEnabled ? "active" : ""} text-primary`}>Tri par date de visite</p>
					<p onClick={() => filterPicker("rendu")} className={`${dateDeRenduEnabled ? "active" : ""} text-primary`}>Tri par date de rendu</p>
					<p onClick={() => filterPicker("affaire")} className={`${affaireEnabled ? "active" : ""} text-primary`}>Affaire à attribuer</p>
				</div>
			</div>
			<div 
				ref={containerRef}
				className="projects-in-progress-container projects-in-progress-engineer-tasks"
				style={{ 
					display: 'flex', 
					flexDirection: 'row', 
					overflowX: 'auto',
					gap: '20px'
				}}
			>
				{projectUnassigned.map((team, index) => {
					return (
						<CardTeam
							key={index}
							team={team}
							manager={roleManager}
							verificateur={roleVerificateur}
							diagnostic={roleDiagnostic}
							extra={roleExtra}
							affaire={roleChargeAffaire}
							timeToRealod={() => setTimeToReload(!timeToRealod)}
							dateDeVisiteEnabled={dateDeVisiteEnabled}
							dateDeRenduEnabled={dateDeRenduEnabled}
						/>
					)
				}
				)}
			</div>
		</div>
	)
}

export default HomeIngManTeams;
